/* 
 * AnimationFactory.js
 * Created on 7-apr-2017
 * @author Swen Meeuwes for &ranj
 */

import SlideTransition from "./transition-animations/SlideTransition";
import CircleTransition from "./transition-animations/CircleTransition";
import RectangleTransition from "./transition-animations/RectangleTransition";
import FadeTransition from "./transition-animations/FadeTransition";
import ZoomTransition from "./transition-animations/ZoomTransition";
import FadeToColorTransition from "./transition-animations/FadeToColorTransition";

export default class AnimationFactory {
    getAnimationByType(animationType) {
        var animation = null;
        switch (animationType) {
            case AnimationFactory.SLIDE_IN_FROM_LEFT:
            case AnimationFactory.SLIDE_IN_FROM_RIGHT:
            case AnimationFactory.SLIDE_IN_FROM_TOP:
            case AnimationFactory.SLIDE_IN_FROM_BOTTOM:
            case AnimationFactory.SLIDE_OUT_TO_LEFT:
            case AnimationFactory.SLIDE_OUT_TO_RIGHT:
            case AnimationFactory.SLIDE_OUT_TO_TOP:
            case AnimationFactory.SLIDE_OUT_TO_BOTTOM:
                animation = new SlideTransition(animationType);
                break;
            case AnimationFactory.CIRCLE_IN:
            case AnimationFactory.CIRCLE_OUT:
                animation = new CircleTransition(animationType);
                break;
            case AnimationFactory.RECTANGLE_IN:
            case AnimationFactory.RECTANGLE_OUT:
                animation = new RectangleTransition(animationType);
                break;
            case AnimationFactory.FADE_IN:
            case AnimationFactory.FADE_OUT:
                animation = new FadeTransition(animationType);
                break;
            case AnimationFactory.ZOOM_IN:
            case AnimationFactory.ZOOM_OUT:
            case AnimationFactory.ZOOM_SLIGHTLY_IN:
            case AnimationFactory.ZOOM_SLIGHTLY_OUT:
                animation = new ZoomTransition(animationType);
                break;

            case AnimationFactory.FADE_TO_COLOR_IN:
            case AnimationFactory.FADE_TO_COLOR_OUT:
                animation = new FadeToColorTransition(animationType);
        }

        return animation;
    };
}

// Slide animation    
AnimationFactory.SLIDE_IN_FROM_LEFT = "ranj.AnimationFactory.SLIDE_IN_FROM_LEFT";
AnimationFactory.SLIDE_IN_FROM_RIGHT = "ranj.AnimationFactory.SLIDE_IN_FROM_RIGHT";
AnimationFactory.SLIDE_IN_FROM_TOP = "ranj.AnimationFactory.SLIDE_IN_FROM_TOP";
AnimationFactory.SLIDE_IN_FROM_BOTTOM = "ranj.AnimationFactory.SLIDE_IN_FROM_BOTTOM";

AnimationFactory.SLIDE_OUT_TO_LEFT = "ranj.AnimationFactory.SLIDE_OUT_TO_LEFT";
AnimationFactory.SLIDE_OUT_TO_RIGHT = "ranj.AnimationFactory.SLIDE_OUT_TO_RIGHT";
AnimationFactory.SLIDE_OUT_TO_TOP = "ranj.AnimationFactory.SLIDE_OUT_TO_TOP";
AnimationFactory.SLIDE_OUT_TO_BOTTOM = "ranj.AnimationFactory.SLIDE_OUT_TO_BOTTOM";

// Circle animation
AnimationFactory.CIRCLE_IN = "ranj.AnimationFactory.CIRCLE_IN";
AnimationFactory.CIRCLE_OUT = "ranj.AnimationFactory.CIRCLE_OUT";

// Rectangle animation
AnimationFactory.RECTANGLE_IN = "ranj.AnimationFactory.RECTANGLE_IN";
AnimationFactory.RECTANGLE_OUT = "ranj.AnimationFactory.RECTANGLE_OUT";

// Fade animation
AnimationFactory.FADE_IN = "ranj.AnimationFactory.FADE_IN";
AnimationFactory.FADE_OUT = "ranj.AnimationFactory.FADE_OUT";

// Zoom animation
AnimationFactory.ZOOM_IN = "ranj.AnimationFactory.ZOOM_IN";
AnimationFactory.ZOOM_OUT = "ranj.AnimationFactory.ZOOM_OUT";
AnimationFactory.ZOOM_SLIGHTLY_IN = "ranj.AnimationFactory.ZOOM_SLIGHTLY_IN";
AnimationFactory.ZOOM_SLIGHTLY_OUT = "ranj.AnimationFactory.ZOOM_SLIGHTLY_OUT";

// Fade to color animation
AnimationFactory.FADE_TO_COLOR_IN = "ranj.AnimationFactory.FADE_TO_COLOR_IN";
AnimationFactory.FADE_TO_COLOR_OUT = "ranj.AnimationFactory.FADE_TO_COLOR_OUT";